// User CRUD operations
export const CREATE_USER = 'providers/AccessManagementUserRole/CREATE_USER';
export const DELETE_USER = 'providers/AccessManagementUserRole/DELETE_USER';

// User relationships
export const ASSIGN_USER_ROLES_TO_APPLICATION = 'providers/AccessManagementUserRole/ASSIGN_USER_ROLES_TO_APPLICATION';
export const GET_USER_ROLES_BY_APPLICATION = 'providers/AccessManagementUserRole/GET_USER_ROLES_BY_APPLICATION';
export const REMOVE_USER_FROM_APPLICATION = 'providers/AccessManagementUserRole/REMOVE_USER_FROM_APPLICATION';

// Legacy v1 (deprecated)
export const GET_USER_ROLE = 'providers/AccessManagementUserRole/GET_USER_ROLE';
export const EDIT_USER_ROLE = 'providers/AccessManagementUserRole/EDIT_USER_ROLE';
